import { useQuery, keepPreviousData } from '@tanstack/react-query';
import axios from 'axios';
import { GEOCODE_APIKEY } from '@/utils/CONST';

interface Params {
    textQuery: string;
}

// interface Output {
//     places: {
//         id: string;
//         formattedAddress: string;
//         location: string;
//     }[];
// }

const useGetPlaces = ({ textQuery }: Params) => {
    const { data } = useQuery({
        queryKey: ['places', textQuery],
        queryFn: () =>
            axios
                .post(
                    'https://places.googleapis.com/v1/places:searchText',
                    {
                        textQuery,
                    },
                    {
                        headers: {
                            'X-Goog-Api-Key': GEOCODE_APIKEY,
                            'X-Goog-FieldMask': 'places.id,places.displayName,places.formattedAddress,places.location',
                        },
                    },
                )
                .then((data) => data.data.places),
        enabled: textQuery !== '',
        placeholderData: keepPreviousData,
    });

    return {
        places: data ?? [],
    };
};

export default useGetPlaces;
